import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { MONTH } from '../../shared/models/mock-data';
import { RegionModel } from '../../shared/models/region';
import { StateModel, ReportDataModel } from '../../shared/models/state';
import { CampaignProvider } from '../../shared/providers/campaign.provider';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../../shared/providers/region.provider';
import { RolesProvider } from '../../shared/providers/roles.provider';
import { StateProvider } from '../../shared/providers/state.provider';

@Component({
  selector: 'app-target-achivements-report',
  templateUrl: './target-achivements-report.component.html',
  styleUrls: ['./target-achivements-report.component.scss']
})
export class TargetAchivementsReportComponent implements OnInit {

  regions: RegionModel[];
  start_date: any;
  states: StateModel[];
  StatesfilterByRegion: StateModel[];
  resetData: any[];
  resetDate: any;
  tseUsers: any[];
  m2Users: any[];
  m3Users: any[];
  tmmUsers: any[];
  //
  tsefilterByStateOrRegion: any[] = [];
  m2filterByStateOrRegion: any[] = [];
  m3filterByStateOrRegion: any[] = [];
  tmmfilterByStateOrRegion: any[] = [];
  /**********************/
  filteredDetails: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",
    month: "",
    year: ""
  };
  filteredDetailsForApi: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",
    program_id: 1,
    month: "",
    year: ""

  };
  resetFilteredDetailsForApi: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",
    month: "",
    year: ""
  };

  resetDropdown: boolean;
  disable: boolean = false;

  min: number;
  max: number;
  years: any[] = [];
  months: any[] = MONTH;

  constructor(private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    public adminDataProvider: AdminDataProvider,
    public campaignProviders: CampaignProvider,
    private formateDate: DateFormateService,
    public regionProviders: RegionProvider,
    public channelProviders: ChannelProvider,
    private userRoles: RolesProvider,
    public stateProvider: StateProvider,
    public alertService: AlertService,
    public exportExcelService: ExportExcelService,
    private ngxService: NgxUiLoaderService,) { }

  ngOnInit() {

    (this.min = 2019), (this.max = new Date().getFullYear());

    for (var i = this.min; i <= this.max; i++) {
      this.years.push({ id: i, name: i });
    }
  }

  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    this.states = this.stateProvider.state;
    this.tseUsers = this.stateProvider.tseUsers;
    this.m2Users = this.stateProvider.m2Users;
    this.m3Users = this.stateProvider.m3Users;
    this.tmmUsers = this.stateProvider.tmmUsers;
  }

  onDateSelected(dates) {
    if (dates) {
      this.filteredDetailsForApi.start_date = this.formateDate.formateDate(
        dates
      );
    }

    if (this.filteredDetailsForApi.start_date != "") {
      this.disable = true;
    }
  }

  selectedDates(dates) {
    if (dates.from) {
      this.filteredDetailsForApi.start_date = this.formateDate.formateDate(
        dates.from
      );
    }
    if (dates.to) {
      this.filteredDetailsForApi.end_date = this.formateDate.formateDate(
        dates.to
      );
    }
    if (!dates.from) {
      this.filteredDetailsForApi.start_date = "";
    }
    if (!dates.to) {
      this.filteredDetailsForApi.end_date = "";
    }

    if (this.filteredDetailsForApi.start_date != "" && this.filteredDetailsForApi.end_date != "") {
      this.disable = true;
    }
  }

  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // resions
        this.filteredDetails.regions = await data;
        this.StatesfilterByRegion = [];
        this.m2filterByStateOrRegion = [];
        this.m3filterByStateOrRegion = [];
        this.tsefilterByStateOrRegion = [];
        this.tmmfilterByStateOrRegion = [];
        let item = data;
        if(data.length == 0) {
          this.disable = false;
        }
        if (item.length > 0) {
          item.forEach((element) => {
            this.StatesfilterByRegion.push(
              ...this.states.filter(
                (s) => s.region_id == element.id && s.state_year == 2021
              )
            );
            this.m2filterByStateOrRegion.push(
              ...this.m2Users.filter(
                (s) => s.region_id == element.id
              )
            );

            this.m3filterByStateOrRegion.push(
              ...this.m3Users.filter(
                (s) => s.region_id == element.id
              )
            );
            this.tsefilterByStateOrRegion.push(
              ...this.tseUsers.filter(
                (s) => s.region_id == element.id
              )
            );
            this.tmmfilterByStateOrRegion.push(
              ...this.tmmUsers.filter(
                (s) => s.region_id == element.id
              )
            );
          });
        }
        break;
      case 2: // State
        this.m2filterByStateOrRegion = [];
        this.m3filterByStateOrRegion = [];
        this.tsefilterByStateOrRegion = [];
        this.tmmfilterByStateOrRegion = [];
        this.filteredDetails.states = await data;
        let statedata = data;
        if(data.length == 0) {
          this.disable = false;
        }
        if (statedata.length > 0) {
          statedata.forEach((element) => {
            this.m2filterByStateOrRegion.push(
              ...this.m2Users.filter(
                (s) => s.state_code == element.id
              )
            );
            this.m3filterByStateOrRegion.push(
              ...this.m3Users.filter(
                (s) => s.state_code == element.id
              )
            );
            this.tsefilterByStateOrRegion.push(
              ...this.tseUsers.filter(
                (s) => s.state_code == element.id
              )
            );
            this.tmmfilterByStateOrRegion.push(
              ...this.tmmUsers.filter(
                (s) => s.state_code == element.id
              )
            );
          });
        }
        break;
      case 3: // city
        this.filteredDetails.tse = await data;
        break;
      case 4: // geography
        this.filteredDetails.m2 = await data;
        break;
      case 5: // geography
        this.filteredDetails.m3 = await data;
        break;
      case 6: // geography
        this.filteredDetails.tmm = await data;
        break;
      case 7: // geography
        this.filteredDetails.month = await data;
        if(data.length == 0) {
          this.disable = false;
        }
        break;
      case 8: // geography
        this.filteredDetails.year = await data;
        if(data.length == 0) {
          this.disable = false;
        }
        break;
      default:
        break;
    }

    if (this.filteredDetails.regions.length > 0 && this.filteredDetails.month.length > 0 && this.filteredDetails.year.length > 0) {
      this.disable = true;
    }
  }

  filterListOfRecords() {
    try {
      this.filteredDetailsForApi.regions = this.filteredDetails.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      let month = this.filteredDetails.month
        .map((i) => i.id)
        .join(",")
        .toString();
      let year = this.filteredDetails.year
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
      this.filteredDetailsForApi.year = year;
      this.filteredDetailsForApi.month = month;
    } catch (error) { }
    console.log(this.filteredDetailsForApi);
    this.getReport(this.filteredDetailsForApi);
  }

  filterResetListOfRecords() {
    this.resetDropdown = true;
    this.resetData = [];
    this.resetDate = undefined;
    this.filteredDetailsForApi = this.resetFilteredDetailsForApi;
    this.disable = true;
    this.start_date = "";
  }

  data: any[] = [];

  searchText: any;

  isLink: boolean;

  data1: ReportDataModel[] = [];

  getReport(data) {
    debugger
    this.ngxService.start();
    this.apiService
      .getMonthlyReports(
        data.month, data.year, data.regions, 2, 2021
      )
      .subscribe(
        (res: any) => {
          if (res.success) {
            if (res.data.flag == "excel") {
              this.isLink = false;
              if (res.data.report_data != undefined || res.data.report_data != null) {
                this.exportExcelService.exportTargetAndAchivementExcel(
                  res.data.report_data
                );
                this.ngxService.stop();
              } else {
                this.alertService.warning(`No Data Found`);
                this.clearSuccess();
                this.ngxService.stop();
              }
            } else if (res.data.flag == "grid") {
              if (res.data.report_batch_data.length == 0) {
                this.data = res.data.message;
                this.isLink = res.data.is_link;
                this.ngxService.stop();
              } else {
                this.data1 = res.data.report_batch_data;
                this.data1.forEach((element) => {
                  let data = element.report_data.split('/');
                  element.report_name = data[data.length - 1];
                  this.ngxService.stop();
                })
              }
            } else {
              this.data = res.data.message;
              this.isLink = res.data.is_link;
              this.ngxService.stop();
            }
          }
        },
        (error) => {
          // unauthorized access
          if (error.status == 401 || error.status == 403) {
          } else {
            // this.alertService.error(error.data.message);
            console.log(error);
            this.ngxService.stop();
          }
        }
      );
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

}
